export const defaultData = {
  learnMorePath: "/professional-services",
};
